import { AzureSubscription } from '../../types/azureSubscription';

export const AZURE_SUBSCRIPTIONS_ANNOTATION = 'equinor.com/azure-subscriptions';

// Matches entries like "R231-Varia/<guid>". Names may contain "/" since the entry is split on the
// trailing "/<guid>". Only GUIDs are accepted as id so annotation values cannot inject arbitrary
// content into the portal URL.
const SUBSCRIPTION_ENTRY_PATTERN =
  /^([^,]+?)\s*\/\s*([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

export function azureSubscriptionsFromAnnotation(
  annotations: Record<string, string> | undefined,
): AzureSubscription[] {
  const raw = annotations?.[AZURE_SUBSCRIPTIONS_ANNOTATION];
  if (!raw) {
    return [];
  }

  return raw
    .split(',')
    .map(entry => SUBSCRIPTION_ENTRY_PATTERN.exec(entry.trim()))
    .filter((match): match is RegExpExecArray => match !== null)
    .map(([, name, id]) => ({
      name,
      id,
      overviewUrl: `https://portal.azure.com/#@/resource/subscriptions/${id}/overview`,
    }));
}
